import { render } from "./DocumentListIframe.vue?vue&type=template&id=7800a932&ts=true"
import script from "./DocumentListIframe.ts?vue&type=script&lang=ts&external"
export * from "./DocumentListIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__